import { InjectionToken } from "@angular/core";

export const IS_PRINT_MODE = new InjectionToken<boolean>('isPrintMode');